<ion-header [class]="headerClass">
  <ng-content></ng-content>
</ion-header>